import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=a285a5e8&scoped=true&"
import script from "./ConnectWallet.vue?vue&type=script&lang=js&"
export * from "./ConnectWallet.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWallet.vue?vue&type=style&index=0&id=a285a5e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a285a5e8",
  null
  
)

export default component.exports